import React, { useMemo, useState } from 'react';
import { AppEngineDefinitionDto } from '../../models/APIModels';
import { Button, Dialog, DialogActions, DialogContent, Grid, TextField } from '@mui/material';
import DialogHeader from './DialogHeader';
import Loader from '../Loader';
import { useForm } from 'react-hook-form';
import { AutoComplete } from '..';
import Progress from '../Loaders/Progress';

interface Iprops {
  open: boolean;
  close: () => void;
  onSave: (engine: AppEngineDefinitionDto) => void;
  isSaving: boolean;
  repositories: [];
}
const CreateEngineModal = ({ open, close, onSave, isSaving, repositories }: Iprops) => {
  const [parentRepository, setParentRepository] = useState();
  
  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm<AppEngineDefinitionDto>({
    defaultValues: {
      engineName: '',
      parentRepositoryId: '',
      engineDescription:'',
      engineId:null
    },
  });

  const handleRepositoryChange = async (repo: any) => {
    setValue('parentRepositoryId', repo.id);
    setParentRepository(repo);
  };
  const onSubmit = async (data: AppEngineDefinitionDto) => {
    // console.log('data', data)
    onSave(data);
  }
  return (
    <>
      <Dialog open={open} onClose={close} fullWidth>
        {isSaving && <Progress progressLabel="Please Wait..." />}
        <DialogHeader onClose={() => close()}>
          <div>{'Create Engine'}</div>
        </DialogHeader>
        <DialogContent dividers>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Engine Name"
                variant="outlined"
                size="small"
                disabled={false}
                placeholder="Enter Engine Name"
                {...register('engineName', { required: true })}
                error={Boolean(errors['engineName'])}
                // required
                inputProps={{
                  maxLength: 250,
                }}
                helperText={errors['engineName'] ? 'Engine Name is required' : ''}
              ></TextField>
            </Grid>
            <Grid item xs={12}>
              <AutoComplete
                id="select-repo"
                items={repositories}
                itemText="name"
                itemKey="id"
                labelText="Parent Repository"
                placeHolderText="Select Parent Repository"
                multiSelect={false}
                {...register('parentRepositoryId', { required: true })}
                onChange={handleRepositoryChange}
                defaultValue={parentRepository}
                isRequired={true}
                hasError={Boolean(errors['parentRepositoryId'])}
                helperText={errors['parentRepositoryId'] ? 'Parent Repository is required' : ''}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" disabled={isSaving} onClick={() => close()}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit(onSubmit)}>
            {'Create'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateEngineModal;
